import React from "react";
import { FormControl, FormLabel, FormErrorMessage, Box, Tooltip } from "@chakra-ui/react";

import { AsyncPaginate } from "react-select-async-paginate";
import { useSelector } from "react-redux";
import { getCategories } from "../../../../api/libs/events";

export default function Categories({ formik, column }) {
	const lang = useSelector(state => state.languageProvider.language);

	const loadOptions = async (searchQuery, loadedOptions, { page }) => {
		if (searchQuery && searchQuery.length < 2) {
			return null;
		}
		const response = await getCategories(page);
		if (formik.values.category_id && page === 1) {
			formik.setFieldValue("category_id", response.data[0]);
		}
		return {
			options: response.data.data,
			hasMore: response.next_page_url,
			additional: {
				page: searchQuery ? 2 : page + 1,
			},
		};
	};

	const onChange = option => {
		formik.setFieldValue("category_id", option);
		formik.setFieldValue("sub_category_id", "");
	};

	return (
		<Tooltip label={formik.errors.category_id} hasArrow arrowSize={15} bg="red.600">
			<FormControl
				display="grid"
				gridTemplateColumns={
					column ? ["1fr", "1fr", "1fr", "1fr", "1fr"] : ["1fr", "1fr", "1fr", "2fr 8fr", "2fr 8fr"]
				}
				alignItems="center"
				isInvalid={formik.errors.category_id && formik.touched.category_id}
				id="category_id"
			>
				<FormLabel
					_focus={{
						color: "#1274BC",
						fontWeight: 700,
					}}
				>
					{lang === "de" ? "Kategorie" : "Category"}
				</FormLabel>
				<Box display="flex" flexDirection="column">
					<AsyncPaginate
						theme={theme => ({
							...theme,
							borderRadius: 0,
						})}
						value={formik.values.category_id || ""}
						loadOptions={loadOptions}
						getOptionValue={option => option.name}
						getOptionLabel={option => option.name}
						onChange={onChange}
						placeholder={
							formik.values.category_id !== "" ? formik.values.category_id : "Auswählen Kategorie"
						}
						additional={{
							page: 1,
						}}
					/>

					{/* <FormErrorMessage
          position={column ? "absolute" : "relative"}
          bottom="-1.2em"
        >
          {formik.errors.category_id}
        </FormErrorMessage> */}
				</Box>
			</FormControl>
		</Tooltip>
	);
}
